import type { StatBlocksMasonryBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { hasText } from '@payloadcms/richtext-lexical/shared'
import { transformImage } from '../../helpers/transforms'
import type { CardMasonryType } from '../atoms/CardMasonry'
import type { CardMasonryImageType } from '../atoms/CardMasonryImage'
import { CMSBlocks } from '../atoms/CMSBlocks'
import { MasonryBlock } from '../blocks/MasonryBlock'

export const StatBlocksMasonryConverter: JSXConverter<
	SerializedBlockNode<StatBlocksMasonryBlock>
> = ({ node, nodesToJSX }) => {
	const { blocks } = node.fields

	const blocksData =
		blocks?.reduce<(CardMasonryType | CardMasonryImageType)[]>((acc, block) => {
			switch (block.blockType) {
				case 'stat-block-stat':
					acc.push({
						id: block.id,
						type: 'stat-blocks-masonry',
						stats: block.stat,
						layout: block.layout,
						theme: block.theme,
						hasDetails: hasText(block.details),
						details: (
							<CMSBlocks>{nodesToJSX({ nodes: block.details?.root?.children || [] })}</CMSBlocks>
						),
					})
					break
				case 'stat-block-image':
					acc.push({
						id: block.id,
						type: 'stat-blocks-masonry-image',
						image: transformImage(block.image),
						layout: block.layout,
					})
					break
				default:
					break
			}
			return acc
		}, []) ?? []

	return <MasonryBlock blocks={blocksData} />
}
